import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LiveJumpComponent } from './live-jump/live-jump.component';
import { LiveSchedulePageComponent } from './live-schedule-page/live-schedule-page.component';
import { WatchLiveComponent } from './watch-live/watch-live.component';

const routes: Routes = [
    { path: '', component: LiveJumpComponent },
    { path: 'qc-members', component: LiveJumpComponent, data: { mode: 'qc-members' } },
    { path: 'qc-public', component: LiveJumpComponent, data: { mode: 'qc-public' } },
    { path: 'streams/:streamID', component: WatchLiveComponent, data: { mode: 'qc-public' } },
    { path: 'schedule', component: LiveSchedulePageComponent },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);